import Model from '@/models/Model.js';

export default class InterventionLog extends Model {
    static entity = 'intervention_logs';

    static modelName = 'InterventionLog';

    static fields() {
        return {
            intervention_id: this.attr(null),
            content: this.attr(null),
            created_at: this.attr(null),
            created_by: this.attr(null),

            intervention: this.belongsTo('interventions', 'intervention_id'),
        };
    }
}
